module.exports = __webpack_public_path__ + "static/media/card4_4.a8fa1198.png";